export const GET_PERSONA_RUOLIGENDER = 'GET_PERSONA_RUOLIGENDER';

/**
 * Get persona genere.
 * @function getPersonaGenere
 * @returns {Object} Get persona genere results action.
 */
export function getPersonaGenere(path) {
  return {
    type: GET_PERSONA_RUOLIGENDER,
    path,
    request: {
      op: 'get',
      path: `${path}/@getRuoliGender`,
    },
  };
}
